import { getData } from "api/dataVisualisation/client";
import { Region } from "components/dataVisualization/restorationZone/RegionFilter";
import { DataDownloadFormat } from "models/dataDownload/dataDownloadFormat";
import {
  DataDownloadModel,
  JsonDataDownloadModel,
} from "models/dataDownload/dataDownloadModel";
import DateFilterModel from "models/filterModels/dateFilterModel";
import { RestorationZoneDemandRestoredModel } from "models/restorationZone/restorationZoneDemandRestored";

import { mapRegionFilterToRequestParamValue } from "./utils";

export const getRestorationZoneDemandRestoredData = async (
  dateFilter: DateFilterModel,
  regionFilter: Region,
  format?: DataDownloadFormat,
  gspGroupId?: string
): Promise<DataDownloadModel<RestorationZoneDemandRestoredModel>> => {
  const { data } = await getData(
    "/datasets/RZDR",
    {
      SubmissionDateTimeFrom: dateFilter.normalisedStartDate.toISOString(),
      SubmissionDateTimeTo: dateFilter.normalisedEndDate.toISOString(),
      Region: mapRegionFilterToRequestParamValue(regionFilter),
      GspGroupId: gspGroupId,
    },
    format
  );
  return data;
};

export const getRestorationZoneDemandRestoredJsonData = (
  dateFilter: DateFilterModel,
  regionFilter: Region
): Promise<JsonDataDownloadModel<RestorationZoneDemandRestoredModel>> =>
  getRestorationZoneDemandRestoredData(
    dateFilter,
    regionFilter,
    DataDownloadFormat.Json
  ) as Promise<JsonDataDownloadModel<RestorationZoneDemandRestoredModel>>;

export const getRestorationZoneDemandRestoredEventsData = async (
  count: number,
  format?: DataDownloadFormat
): Promise<DataDownloadModel<RestorationZoneDemandRestoredModel>> => {
  const { data } = await getData(
    "/demand/by-restoration-zone/restored/submissions",
    {
      count,
    },
    format
  );
  return data;
};

export const getRestorationZoneDemandRestoredEventsJsonData = (
  count: number
): Promise<JsonDataDownloadModel<RestorationZoneDemandRestoredModel>> =>
  getRestorationZoneDemandRestoredEventsData(
    count,
    DataDownloadFormat.Json
  ) as Promise<JsonDataDownloadModel<RestorationZoneDemandRestoredModel>>;
